export const tableColunms = [
    'wbs',
    '问题类型',
    '描述',
    '提出人',
    '执行',
    '执行人',
    '开始日期',
    '结束日期',
    '完成率',
    '文件',
    '所需帮助',
    '操作'
]